import styled from 'styled-components';

export const Wrapper = styled.div`
  color: var(--color-text-light);
  @media (${({ theme }) => theme.respondTo.tablet}) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Title = styled.h2`
  font-size: 3rem;
  margin-bottom: 2rem;
  @media (${({ theme }) => theme.respondTo.tablet}) {
    font-size: 3.8rem;
    font-family: var(--font-tertiary);
    font-weight: var(--font-weight-regular);
    line-height: 1.4;
  }
`;

export const Text = styled.div`
  margin-top: 5.7rem;
  @media (${({ theme }) => theme.respondTo.tablet}) {
    margin-top: 0;
  }

  font-size: 1.6rem;

  h3 {
    font-size: 1.9rem;
    line-height: 175%;
    margin-bottom: 2rem;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 6.3rem;
  @media (${({ theme }) => theme.respondTo.tablet}) {
    margin-top: 5rem;
  }
`;

export const Column = styled.div`
  font-size: var(--font-size-sm);
  line-height: 1.75;
  @media (${({ theme }) => theme.respondTo.tablet}) {
    flex: 50%;
    max-width: 46rem;
    font-size: var(--font-size-base);
  }
`;
